import visitorSettings from "./visitorSettings"
import visitorManage from "./visitorManage"

const visitorModules = {
  visitorSettings,
  visitorManage,
}
export default visitorModules
